<template>
  <div class="grid seatdetail" >
    <div class="grid single" v-if="seats.length === 1">
      <div class="grid header">
        <div class="grid seat editseat selected">
          <span class="grid id">{{seat.ombrid}}</span>
        </div>  
      </div>
      <div class="grid settings">
        <!-- {{$store.state.hotels.activehotel.segments}} -->
        <!-- {{seat}} -->
        <div class="grid setting full">
          <span>
            <el-form key="form" ref="segmentform" :model="seat" status-icon v-if="!firsttime">
              <el-form-item label="ID Ombrellone" >
                <el-input type="text" v-model="seat.ombrid" name="ombrid" class="border"></el-input>
              </el-form-item>
            </el-form>
          </span>
        </div>
        <div class="grid setting">
          <span>Visibile</span>
          <el-switch
            v-model="seat.visible"
            active-color="#13ce66"
            inactive-color="#ddd">
          </el-switch>
        </div>
        <!-- <div class="grid setting">
          <span>Segmento</span>
        </div> -->
      </div>
      <div class="grid footer">
        <div class="grid btnlist" key="btnlist">
            <button type="button" class="btn" @click="$emit('closeseatDialog')">
                <unicon name="times" height="16" width="16" fill="#333" />
            </button>
            <button type="button" class="btn green block" @click="$emit('save')">conferma modifiche</button>
        </div>
      </div>
    </div>
    <!-- <div class="grid header">
      <div class="grid seat editseat selected">
        <span class="grid id">{{seat.ombrid}}</span>
      </div>
    </div> -->
    <div class="grid multiple" v-if="seats.length > 1">
      <div class="grid header">
<!--         <div class="grid seat editseat selected">
          <span class="grid id">{{seat.ombrid}}</span>
        </div>   -->
      </div>
      <div class="grid settings">
        
        <!-- <div class="grid seats"> -->
            <!-- {{firsttime}} -->
            <!-- {{seat}} -->
            <!-- {{seats}} -->
<!--             <div class="grid" v-for ="(seat, index) in seats" :key="index">
              <div class="grid seat editseat selected">
                      <span class="grid id">{{seat.ombrid}}</span>
                    </div>
              <el-form key="form" ref="segmentform" :model="seat" status-icon v-if="!firsttime">
                <div class="grid seat editseat selected">
                  <el-form-item label="ID Ombrellone" >
                    <el-input type="text" v-model="seat.ombrid" name="ombrid"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>

            <el-form key="form" ref="segmentform" :model="seat" status-icon v-if="firsttime">
                <el-form-item label="ID Ombrellone" >
                  <el-input type="text" v-model="seat.ombrid" name="ombrid"></el-input>
                </el-form-item>
              </el-form>
            <button class="btn sm green" @click="updateSeat()">update</button>

          </div> -->
          <div class="grid" v-if="seats.length !== 1 && !firsttime">
            <el-form key="form" ref="segmentform" :model="createsegment" status-icon v-if="createsegment.open">
              <!-- {{createsegment.color}} -->
              <el-form-item label="nome segmento" >
                <el-input type="text" v-model="createsegment.name" name="baseprice"></el-input>
              </el-form-item>
              <el-form-item label="colore segmento" >
                <el-color-picker v-model="createsegment.color" @active-change="changecolor"></el-color-picker>
              </el-form-item>
            </el-form>
            <button @click="createsegment.open ? $store.dispatch('hotels/addSegment', {name: createsegment.name, seats: seats, color: createsegment.color}) : createsegment.open = true" class="btn green sm" v-loading="updateloading" key="update"><unicon name="save" fill="#fff" /> crea segmento</button>
          </div>      

      </div>
    </div>
  
<!--   <div class="grid" style="height: 100%;">
    <el-form key="form" ref="seatform" :rules="rules" :model="seat" status-icon>

      <el-form-item v-for="season in seat.seasons" :key="season.name" :label="'Prezzo stagione ' + season.name" >
        <el-input type="text" v-model="season.baseprice" name="baseprice"></el-input>
      </el-form-item>

    </el-form>

    <div class="spacer xs"></div>

    <button @click="update('seatform')" class="btn green sm" v-loading="updateloading" key="update"><unicon name="save" fill="#fff" /> salva modifiche</button>
  </div> -->
  </div>
</template>

<script>
// import Moment from 'moment'
// import { extendMoment } from 'moment-range'
// const moment = extendMoment(Moment)
// import _ from 'lodash'
export default {
  name: 'Editseat',
  props: {
    seat: [Object, String],
    seats: Array,
    firsttime: Boolean
  },
  data () {
  return {
    createsegment: {
      open: false,
      name: '',
      color: ''
    },
    rules: {
      ombrid: [
        { required: true, message: 'prego inserire un nome', trigger: 'blur' }
      ]
      // range: [
      //  { validator: checkRange, trigger: 'blur' }
      // ]
    }
  }
  },
  methods: {
    updateSeat () {
      console.log(this.seats)
      // this.$emit('updateSeat', this.seats)
      this.$store.dispatch('ombrelloni/updateOmbrids', {seats: this.seats}).then(data => {
        console.log(data)
        this.$emit('closeseatDialog', data)
      }, error => {
        this.$emit('closeseatDialog', error)
      })
    },
    // createsegment () {
    //   console.log(this.seats)
    // },
    changecolor (color) {
      // console.log(color)
      this.createsegment.color = color
    },
    update (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('update', this.seat)
          this.$store.dispatch('ombrelloni/updateOmbrelloni', {seats: this.seats, seat: this.seat}).then(data => {
            console.log(data)
            this.$emit('closeseatDialog', data)
          }, error => {
            this.$emit('closeseatDialog', error)
          })
          // this.$store.dispatch('guests/getGuests')
        } else {
          console.log('error submit!!')
          // return false
        }
      })
    }
  },
  watch: {

  },
  filters: {

  },
  computed: {
    updateloading () {
      return this.$store.state.ombrelloni.loading
    }
  },
  beforeMount () {
    if (this.seats.length > 1) {
      this.createsegment.open = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
</style>
